import { Helmet } from "react-helmet-async";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { News } from "@/components/News";
import { Courses } from "@/components/Courses";
import { Services } from "@/components/Services";
import { BFC } from "@/components/BFC";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { TrophyPopup } from "@/components/TrophyPopup";

const coursesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: [
    {
      "@type": "Course",
      name: "Curso Profesional de Barista",
      description: "Formación completa para baristas: extracción de espresso, molienda, calidad del café y servicio.",
      provider: { "@type": "Person", name: "Federico Duronio", url: "https://federicoduronio.com/" },
    },
    {
      "@type": "Course",
      name: "Curso de Latte Art",
      description: "Técnicas de texturizado de leche y diseño de figuras de latte art con un Campeón Nacional.",
      provider: { "@type": "Person", name: "Federico Duronio", url: "https://federicoduronio.com/" },
    },
    {
      "@type": "Course",
      name: "Curso Personalizado de Café",
      description: "Programa de formación a medida para cafeterías, hoteles y profesionales del café.",
      provider: { "@type": "Person", name: "Federico Duronio", url: "https://federicoduronio.com/" },
    },
  ],
};

const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Consultoría para cafeterías y distribución de máquinas BFC",
  provider: { "@type": "Person", name: "Federico Duronio", url: "https://federicoduronio.com/" },
  areaServed: "ES",
  description: "Consultoría integral para cafeterías: carta de café, formación de equipo, optimización de máquina, asesoría de apertura y máquinas BFC.",
};

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Cursos de Café, Consultoría y Máquinas BFC | Federico Duronio</title>
        <meta name="description" content="Cursos de barista y latte art, consultoría para cafeterías y máquinas BFC en España. Formación con Federico Duronio, Campeón Nacional de Latte Art." />
        <link rel="canonical" href="https://federicoduronio.com/home" />
        <meta property="og:title" content="Cursos de Café, Consultoría y Máquinas BFC | Federico Duronio" />
        <meta property="og:description" content="Cursos de barista y latte art, consultoría para cafeterías y máquinas BFC con Federico Duronio." />
        <meta property="og:url" content="https://federicoduronio.com/home" />
        <script type="application/ld+json">{JSON.stringify(coursesSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(servicesSchema)}</script>
      </Helmet>
      <Navigation />
      <Hero />
      <About />
      <News />
      <Courses />
      <Services />
      <BFC />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <TrophyPopup />
    </div>
  );
};

export default Index;
